export enum LineDrawingType {
  FromTop = 0,
  FromCenter = 1,
  FromBottom = 2
}
